import { ArrowRight, Check } from "lucide-react";
import { FadeUp, MaskLines } from "./Reveal";

const PRODUCTS = [
  {
    n: "Product 01",
    name: "AI Chat Bot",
    sub: "Simplifying conversations through AI",
    d: "Automates customer chats, qualifies leads and answers instantly across web and WhatsApp.",
    pills: [
      "Conversational AI",
      "Lead Qualification",
      "Smart Integrations",
      "24/7 Automation",
      "Multichannel Support",
      "Enterprise Security",
    ],
    img: "https://static.prod-images.emergentagent.com/jobs/c2bc19df-5c82-426d-a525-b1b5482481fd/images/2451ecfc78689649f081f2a7c0d1bc69d32bca4c201b5bfd92d7f6ac738e8f6d.jpeg",
    alt: "AI Chat Bot CRM dashboard",
  },
  {
    n: "Product 02",
    name: "AI Caller",
    sub: "Voice conversations that scale",
    d: "Handles outbound calls, follow-ups and reminders with human-like accuracy.",
    pills: [
      "AI Voice Agents",
      "Outbound Calls",
      "Automated Follow-Ups",
      "Real-Time Insights",
      "CRM Integration",
      "Secure & Scalable",
    ],
    img: "https://static.prod-images.emergentagent.com/jobs/c2bc19df-5c82-426d-a525-b1b5482481fd/images/48b1a747b2e1c1ea4bede592b11b98da46997b6c3224726d4f63378e837321ad.jpeg",
    alt: "AI Caller voice dashboard",
  },
];

function Shot({ idx, img, alt }) {
  return (
    <div
      className="aspect-[6/5] w-full overflow-hidden rounded-lg border border-black/[0.06] bg-[#E8E6E1]"
      data-testid={`product-screenshot-${idx}`}
    >
      <img
        src={img}
        alt={alt}
        loading="lazy"
        className="h-full w-full object-cover object-top transition-transform duration-500 hover:scale-[1.02]"
      />
    </div>
  );
}

export default function AIProducts() {
  return (
    <section id="ai-products" className="scroll-mt-20 bg-paper py-24 text-[#0f0f14] md:py-28">
      <div className="mx-auto max-w-[1160px] px-6">
        <div className="grid items-end gap-10 lg:grid-cols-[1.35fr_0.65fr]">
          <div>
            <FadeUp>
              <p
                className="text-[13px] font-semibold uppercase tracking-[0.18em] text-brand"
                data-testid="ai-products-eyebrow"
              >
                03 — AI Products
              </p>
            </FadeUp>
            <MaskLines
              lines={["Two products", "that answer every", "customer, day or night."]}
              className="mt-8 text-[clamp(2.4rem,4.9vw,4.4rem)] font-normal leading-[1.04] tracking-[-0.025em]"
            />
          </div>
          <FadeUp delay={0.1}>
            <p className="max-w-[470px] text-[17px] leading-[1.65] text-[#54545c]">
              Trained on your business, connected to your systems, live in weeks.
            </p>
          </FadeUp>
        </div>

        <div className="mt-24 space-y-28">
          {PRODUCTS.map((p, i) => (
            <div
              key={p.name}
              className="grid items-center gap-12 lg:grid-cols-2 lg:gap-16"
              data-testid={`ai-product-row-${i + 1}`}
            >
              <div className={i % 2 === 1 ? "lg:order-2" : ""}>
                <Shot idx={i + 1} img={p.img} alt={p.alt} />
              </div>
              <FadeUp delay={0.08} className={i % 2 === 1 ? "lg:order-1" : ""}>
                <p className="text-[14px] font-semibold uppercase tracking-[0.16em] text-brand">
                  {p.n}
                </p>
                <h3 className="mt-6 text-[clamp(2.2rem,3.4vw,3rem)] font-normal tracking-[-0.02em]">
                  {p.name}
                </h3>
                <p className="mt-6 text-[24px] font-semibold tracking-[-0.01em]">{p.sub}</p>
                <p className="mt-4 max-w-[560px] text-[17px] leading-[1.65] text-[#54545c]">{p.d}</p>
                <div className="mt-8 flex flex-wrap gap-3">
                  {p.pills.map((pill) => (
                    <span
                      key={pill}
                      className="inline-flex items-center gap-2 rounded-full border border-black/[0.09] bg-white px-4 py-2 text-[15px] font-medium"
                    >
                      <Check className="h-4 w-4 text-brand" strokeWidth={2.75} />
                      {pill}
                    </span>
                  ))}
                </div>
                <a
                  href="#contact"
                  data-testid={`book-demo-${i + 1}-btn`}
                  className="group mt-10 inline-flex items-center gap-2 rounded-[12px] border border-black/[0.12] bg-white px-6 py-3.5 text-[15px] font-medium transition-colors duration-300 hover:border-black/35"
                >
                  Book a Demo
                  <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
                </a>
              </FadeUp>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
